import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BodAppBar from "./BodAppBar";
import axios from "axios";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { toast, ToastContainer } from "react-toastify";
import { showErrorToast } from "../../Constant/Notification";

const LeadSplit = () => {
  const navigate = useNavigate();
  const loc = useLocation();

  const userData = JSON.parse(localStorage.getItem("userData"));
  const teamId = userData?.teamId?.[0]?.id;
  console.log(loc.state);
  const handleBack = () => {
    navigate("/bod/dashboard");
  };

  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  // let teamMem = [];
  // Object.keys(loc.state.teamMembers).forEach((item) => {
  // teamMem.push({id: item, name:loc.state.teamMembers[item],count:0})
  // });

  useEffect(() => {
    let teamMem = [];
    if (loc && loc.state && loc.state.teamMembers) {
      Object.keys(loc.state.teamMembers).forEach((item) => {
        teamMem.push({ id: item, name: loc.state.teamMembers[item], count: 0 });
      });

      // Sort before setting state
      teamMem.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      console.error("loc.state.teamMembers is not defined");
    }
    setTeamMembers(teamMem);
  }, [loc]);

  // },[]);

  const handleChange = (e, index, value) => {
    const inputValue = parseInt(e.target.value) || 0;
    let updateMembers = [...teamMembers];
    updateMembers[index]["count"] = inputValue;
    const totalAssigned = updateMembers.reduce(
      (sum, item) => sum + (item.count || 0),
      0
    );

    if (totalAssigned > loc.state.totalCount) {
      showErrorToast("Total assigned count cannot exceed available leads.");
      return;
    }

    setTeamMembers(updateMembers);
  };

  const handleSubmit = () => {
    let assignObj = {};
    let totalAssignedLeads = 0;
    teamMembers.forEach((item) => {
      assignObj[item.id] = parseInt(item.count);
      totalAssignedLeads += parseInt(item.count);
    });

    if (totalAssignedLeads === 0) {
      toast.error("Atleast one Lead should be assign", {
        position: "top-center",
        theme: "light",
        className: "absolute top-20",
      });
      return;
    }
    let obj = { assigneeCount: assignObj };
    obj = { ...obj, teamId: teamId, status: "Fresh" };
    console.log(obj);
    setLoading(true);
    axios
      .post(
        "https://client-glfunnel-service-144135692330.asia-south1.run.app/api/v1/leads/assign",
        obj
      )
      .then((response) => {
        navigate("/bod/dashboard", {
          state: { message: "Lead splited Successfully" },
        });
      })
      .catch((error) => {
        console.error("There was an error", error);
        // alert("failed");
        toast.error("There was an error", {
          position: "top-center",
          theme: "light",
          className: "absolute top-20",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="bg-appGrayBackground   pt-20 pb-10">
       <AdminAppBar />
      <ToastContainer />
      <div className="">
        <div className="flex mx-14 mt-10 items-center ">
          <svg
            onClick={handleBack}
            className=" "
            width="20"
            height="28"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>
          <h2 className="text-4xl font-medium ml-5 xl:text-3xl 4xl:text-4xl ">
            Assign Leads
          </h2>
        </div>
      </div>
      <div className="w-11/12 mx-20">
        <div className="  justify-between  mt-10 flex xl:text-2xl 4xl:mt-36 3xl:text-3xl 4xl:text-6xl">
          <div className="px-5 rounded-lg bg-white h-11 w-96 text-xl pt-2 shadow-md font-semibold flex gap-10 4xl:text-4xl whitespace-nowrap 4xl:w-auto 4xl:h-14 ">
            <div>Total Availables Leads:</div>
            <div className="">{loc.state.totalCount}</div>
          </div>
          <button
            className="bg-customGreen text-white h-11 w-48   rounded-md md:text-xl
          lg:text-2xl xl:text-xl 2xl:text-2xl font-medium 4xl:text-4xl whitespace-nowrap 4xl:w-64 4xl:h-14"
            onClick={handleSubmit}
            disabled={loading}
          >
            {" "}
            {loading ? (
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white"></div>
              </div>
            ) : (
              "Assign"
            )}
          </button>
        </div>
        <div className="bg-white w-full shadow-md mt-8  rounded-lg p-4 pb-10 4xl:h-[400px]">
          <h1 className="text-3xl font-semibold xl:text-2xl 3xl:text-3xl 4xl:text-4xl">
            Splitting Across Teams
          </h1>
          <div className="flex mt-8  gap-20">
            <div className="grid grid-cols-2 gap-10 w-full">
              {teamMembers
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((value, index) => {
                  return (
                    <div className="flex justify-around 4xl:mt-8" key={index}>
                      <label className="  w-40 font-medium text-xl xl:text-base 3xl:text-2xl 4xl:text-3xl whitespace-nowrap">
                        {" "}
                        {value.name}
                      </label>
                      <input
                        type="text"
                        className=" text-center focus:outline-none h-10 w-48 xl:text-base 3xl:text-2xl 4xl:text-4xl 4xl:border-gray-400 whitespace-nowrap 4xl:w-auto 4xl:h-14 border rounded-md border-gray-300 focus:border-blue-500"
                        onChange={(e) => handleChange(e, index, value)}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadSplit;
